import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Flame, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTrendingProducts } from '@/hooks/useApi.js';
import { ProductCard } from '@/components/products/ProductCard';

export function TrendingProducts() {
  const { data: trendingData, isLoading, error } = useTrendingProducts(0, 8);

  const trendingProducts = trendingData?.content || [];

  return (
    <section className="py-16 md:py-24 bg-secondary/30">
      <div className="container mx-auto px-4">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10 md:mb-14"
        >
          <div>
            <div className="flex items-center gap-2 mb-3">
              <Flame className="h-5 w-5 text-primary" />
              <span className="text-primary font-medium text-sm uppercase tracking-wider font-sans">
                Hot Right Now
              </span>
            </div>
            <h2 className="section-heading font-serif">Trending This Week</h2>
            <p className="section-subheading font-sans">Most loved by our customers</p>
          </div>
          <Link to="/trending" className="hidden md:block">
            <Button variant="outline" className="gap-2 font-sans">
              View All
              <ArrowRight className="h-4 w-4" />
            </Button>
          </Link>
        </motion.div>

        {/* Products Grid */}
        {isLoading ? (
          <div className="flex justify-center items-center py-12">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
            <span className="ml-2 text-lg">Loading trending products...</span>
          </div>
        ) : error ? (
          <div className="text-center py-12">
            <p className="text-red-500 mb-4">Failed to load trending products</p>
            <Button onClick={() => window.location.reload()}>Try Again</Button>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {trendingProducts.map((product, index) => (
              <motion.div
                key={product.productId || product.id || index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.05 }}
              >
                <ProductCard product={product} />
              </motion.div>
            ))}
          </div>
        )}

        {/* Mobile View All */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-8 text-center md:hidden"
        >
          <Link to="/trending">
            <Button variant="outline" className="gap-2 font-sans">
              View All Trending
              <ArrowRight className="h-4 w-4" />
            </Button>
          </Link>
        </motion.div>
      </div>
    </section>
  );
}